document.addEventListener('DOMContentLoaded', () => {

  const slides = document.querySelectorAll('.hero-slide');

  let currentSlide = 0;

  if(!slides.length) return;

  slides[0].classList.add('active');

  function showSlide(index){

    slides.forEach(slide => {
      slide.classList.remove('active');
    });

    slides[index].classList.add('active');

    currentSlide = index;

  }

  setInterval(() => {

    let nextSlide = currentSlide + 1;

    if(nextSlide >= slides.length){
      nextSlide = 0;
    }

    showSlide(nextSlide);

  }, 5000);

});